import $ from 'jquery';
import { dataLayerEventExist } from './site/helpers';

document.addEventListener('DOMContentLoaded', function () {
  const workItems = document.querySelectorAll('.work-item');

  workItems.forEach((item) => {
    const itemTitle = item.querySelector('h3').innerText;
    let hoverTimer;

    item.addEventListener('mouseenter', function () {
      hoverTimer = setTimeout(() => {
        if (!dataLayerEventExist('workItemHover', itemTitle)) {
          window.dataLayer.push({
            event: 'workItemHover',
            eventLabel: itemTitle
          });
        }
      }, 2000);
    });

    item.addEventListener('mouseleave', function () {
      clearTimeout(hoverTimer);
    });

    item.addEventListener('touchstart', function () {
      if (!dataLayerEventExist('workItemHover', itemTitle)) {
        window.dataLayer.push({
          event: 'workItemHover',
          eventLabel: itemTitle
        });
      }
    });
  });

  // --------------------------------------------------
  // Portfolio Filtering
  // --------------------------------------------------

  const $grid = $('#post-grid');
  const $allItems = $grid.find('.work-item').sort(function (a, b) {
    return new Date($(b).data('date')) - new Date($(a).data('date'));
  });
  const $featuredBtn = $('.work-filters__featured');
  const $industrySelect = $('#filter-industry');
  const $serviceSelect = $('#filter-service');
  const $loadMore = $('#load-more');

  const POSTS_PER_PAGE = 10;
  let featuredActive = false;
  let visibleCount = POSTS_PER_PAGE;

  function getFilteredItems() {
    const selectedIndustry = $industrySelect.val();
    const selectedService = $serviceSelect.val();
    const filtered = [];

    $allItems.each(function () {
      const $item = $(this);
      let show = true;

      if (featuredActive) {
        if (
          $item.data('featured') !== true &&
          $item.data('featured') !== 'true'
        ) {
          show = false;
        }
      } else {
        if (selectedIndustry) {
          const industries = ($item.data('industry') || '')
            .toString()
            .split(' ');
          if (industries.indexOf(selectedIndustry) === -1) {
            show = false;
          }
        }

        if (selectedService) {
          const services = ($item.data('service') || '').toString().split(' ');
          if (services.indexOf(selectedService) === -1) {
            show = false;
          }
        }
      }

      if (show) {
        filtered.push($item);
      }
    });

    return filtered;
  }

  function redistributeColumns(items) {
    $grid.find('.work-grid__col').remove();

    const $leftCol = $('<div class="work-grid__col"></div>');
    const $rightCol = $('<div class="work-grid__col"></div>');

    items.forEach(($item, i) => {
      $item.css({
        opacity: 0,
        transform: 'translateY(20px)'
      });

      if (i % 2 === 0) {
        $leftCol.append($item);
      } else {
        $rightCol.append($item);
      }

      setTimeout(() => {
        $item.css({
          transition: 'opacity 0.4s ease, transform 0.4s ease',
          opacity: 1,
          transform: 'translateY(0)'
        });
      }, i * 60);
    });

    $grid.append($leftCol, $rightCol);
  }

  function render() {
    const filtered = getFilteredItems();
    const toShow = filtered.slice(0, visibleCount);

    redistributeColumns(toShow);

    // Show/hide load more button
    if (visibleCount >= filtered.length) {
      $loadMore.hide();
    } else {
      $loadMore.show();
    }
  }

  function filterPosts() {
    visibleCount = POSTS_PER_PAGE;
    render();
  }

  // Load more
  $loadMore.on('click', function () {
    visibleCount += POSTS_PER_PAGE;
    render();
  });

  // Featured toggle
  $featuredBtn.on('click', function () {
    featuredActive = !featuredActive;
    $(this).toggleClass('active');

    if (featuredActive) {
      $industrySelect.val('');
      $serviceSelect.val('');
    }

    filterPosts();
  });

  // Dropdown filters
  $industrySelect.on('change', function () {
    if (featuredActive) {
      featuredActive = false;
      $featuredBtn.removeClass('active');
    }
    filterPosts();
  });

  $serviceSelect.on('change', function () {
    if (featuredActive) {
      featuredActive = false;
      $featuredBtn.removeClass('active');
    }
    filterPosts();
  });

  // --------------------------------------------------
  // Custom dropdown UI
  // --------------------------------------------------

  $('.work-filters__dropdown').each(function () {
    const $wrapper = $(this);
    const $select = $wrapper.find('select');
    const defaultText = $select.find('option').first().text();

    // Build trigger button
    const $trigger = $('<button type="button" class="work-filters__dropdown-trigger"></button>').text(defaultText);

    // Build options list
    const $menu = $('<ul class="work-filters__dropdown-menu"></ul>');
    $select.find('option').each(function () {
      const $opt = $(this);
      const $li = $('<li class="work-filters__dropdown-option"></li>')
        .text($opt.text())
        .attr('data-value', $opt.val());
      if ($opt.val() === '') {
        $li.addClass('is-selected');
      }
      $menu.append($li);
    });

    $wrapper.append($trigger, $menu);

    // Toggle open/close
    $trigger.on('click', function (e) {
      e.stopPropagation();
      const wasOpen = $wrapper.hasClass('is-open');
      // Close all dropdowns first
      $('.work-filters__dropdown').removeClass('is-open');
      if (!wasOpen) {
        $wrapper.addClass('is-open');
      }
    });

    // Select an option
    $menu.on('click', '.work-filters__dropdown-option', function () {
      const $opt = $(this);
      const val = $opt.data('value');

      // Update selected state
      $menu.find('.work-filters__dropdown-option').removeClass('is-selected');
      $opt.addClass('is-selected');

      // Update trigger text
      $trigger.text($opt.text());

      // Sync native select and trigger change
      $select.val(val).trigger('change');

      // Close
      $wrapper.removeClass('is-open');
    });
  });

  // Close dropdowns on outside click
  $(document).on('click', function () {
    $('.work-filters__dropdown').removeClass('is-open');
  });

  // Close on Escape
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      $('.work-filters__dropdown').removeClass('is-open');
    }
  });

  // Initial render
  render();
});
